<template>
  <div
    id="div_tcselector"
    class="tcs"
  >
    <button
      class="tcs_btn"
      type="button"
      id="tc_dropDown"
      @click="showOption=!showOption"
    >
      <span
        class="tcs_btn-text"
      >
        {{str_tc_list}}
      </span>
    </button>
    <div
      v-show="showOption"
      id="div_tc_options"
      class="tcs_option"
    >
      <template v-for="(tc_info, index) in get_tc_info_list">
        <div
          :key="'div_for_tc'+index"
          class="tcs_option-box"
        >
          <label
            :key="'label_for_tc'+index"
            class="tcs_option-items"
          >
            <input
              type="checkbox"
              class="tcs_option-items-checkbox"
              :id="'checkbox_'+tc_info.name"
              :key="'tc_checked'+index"
              :value="tc_name(tc_info)"
              :checked="selected_tc_info_options.includes(tc_info.name)"
              @change="set_selected_tc_info(tc_info, $event.target.checked)"
            >
            <span>
              {{tc_name(tc_info)}}
            </span>
          </label>
          <button
            :key="'btn_for_tc'+index"
            @click="focus_tc(tc_info.name)"
          >
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'TCSelector',
  data () {
    return {
      showOption: false
    }
  },

  methods: {
    ...mapActions({
      set_options: types.SET_OPTIONS
    }),

    tc_name (tcInfo) {
      return tcInfo.CWB || tcInfo.name
    },

    set_selected_tc_info: function (tc_info, checked) {
      let selected_tc = this.selected_tc_info_options
      let index = selected_tc.indexOf(tc_info.name)

      if (checked) {
        if (index < 0) {
          selected_tc.push(tc_info.name)
        }
      } else {
        if (index >= 0) {
          selected_tc.splice(index, 1)
        }
      }
      this.set_options({'selected_tc': selected_tc})
    },

    focus_tc (tcName) {
      this.set_options({'focused_tc': tcName})
    }
  },

  computed: {
    ...mapGetters({
      get_tc_info_list: types.GET_TC_INFO_LIST,
      get_options: types.GET_OPTIONS
    }),

    str_tc_list () {
      return this.get_tc_info_list.map((val, i, arr) => {
        return this.tc_name(val)
      }).join()
    },

    selected_tc_info_options () {
      return this.get_options.selected_tc
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/typhoon_tw/TCSelector.vue